var convert = require('./convert'),
    func = convert('sortBy', require('../sortBy'));

func.placeholder = require('./placeholder');
module.exports = func;



/*****************
 ** WEBPACK FOOTER
 ** ./~/semantic-ui-react/~/lodash/fp/sortBy.js
 ** module id = 4044
 ** module chunks = 0
 **/